/**
 * Avatar Service
 */

DM.Service.Avatar = (function () {
    var endpoint = '/Profile/ChangeAvatar';

    return {
        upload: function (data) {
            return fetch(endpoint, {
                method: 'POST',
                cache: 'no-cache',
                body: data
            }).then(response => response.json());
        }
    };

})();
